import { cn } from "cn";
import type * as React from "react";

// A loading placeholder in the v3.2 sunken surface. Size it with classes;
// put `aria-hidden` (or a status label) on the group around it.
export function Skeleton({
  className,
  ...props
}: React.ComponentPropsWithRef<"div">): React.JSX.Element {
  return (
    <div
      className={cn("animate-pulse rounded-[8px] bg-v3-surface-2", className)}
      data-slot="skeleton"
      {...props}
    />
  );
}

// A list row placeholder (icon tile, title and a line under it), as the
// rows of the Templates and Macros lists.
export function SkeletonRow({
  className,
}: {
  className?: string;
}): React.JSX.Element {
  return (
    <div
      className={cn(
        "flex min-h-[72px] items-center gap-3 px-4 py-3 sm:px-5",
        className,
      )}
      data-slot="skeleton-row"
    >
      <Skeleton className="size-10 shrink-0 rounded-[10px]" />
      <div className="min-w-0 flex-1 space-y-2">
        <Skeleton className="h-4 w-1/2 max-w-xs" />
        <Skeleton className="h-3 w-3/4 max-w-sm" />
      </div>
    </div>
  );
}
